import { render } from "./SelectMenu.vue?vue&type=template&id=5556d875"
import script from "./SelectMenu.vue?vue&type=script&lang=ts"
export * from "./SelectMenu.vue?vue&type=script&lang=ts"
script.render = render

export default script